import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Image from "gatsby-image"
import Parser from "html-react-parser"
import { saveLead, checkEmail } from "../../utils/emails"
import Spinner from "../../images/meets/Spinner.gif"

import { Row, Col, Card, InputGroup, FormControl } from "react-bootstrap"

export let ShowInscription = props => {
  const [toVideo, setToVideo] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [email, setEmail] = useState()
  const [loading, setLoading] = useState(true)
  const [disabledButton, setDisabledButton] = useState(false)

  const handleSuccess = () => {
    saveLeads(email)
    setToVideo(true)
    console.log("funcionaaaaa")
  }

  const saveLeads = async email => {
    setLoading(false)
    if (checkEmail(email)) {
      await saveLead(email, props.idMail, props.templateId, props.text, email)

      setLoading(false)
      setSubmitted(true)
    }
  }

  const BtnSend = styled.button`
    background-color: ${props => props.btnInputColor} !important;
    padding: 1rem 3rem 1rem 3rem;
    border-radius: ${props => props.btnBorderRadius};
    border: ${props => props.btnBorder} !important;
    /*  border-width: 0; */
    :active {
      background-color: ${props => props.btnInputColor} !important;
    }
    :hover {
      background-color: ${props => props.btnInputColor} !important;
    }
    :visited {
      background-color: ${props => props.btnInputColor} !important;
    }
    :link {
      background-color: ${props => props.btnInputColor} !important;
    }
    @media (max-width: 484px) {
      padding: 1rem 7.2rem 1rem 7.2rem;
    }
  `
  return (
    <>
      <section
        id="section-inscription"
        style={{
          backgroundColor: props.colorInput,
          paddingBottom: "15rem",
          paddingTop: "5rem",
        }}
      >
        <Row style={{ justifyContent: "center" }}>
          <Title>
            {!submitted &&
              Parser(" Inscríbete <br> <small>a este gran evento </small> ")}

            {submitted &&
              Parser(
                "Muchas gracias, dentro de poco te enviaremos la invitación <br> 🥰🤓🥳"
              )}
          </Title>
        </Row>
        {!submitted && (
          <Row style={{ justifyContent: "center" }}>
            <form
              style={{
                justifyContent: "center",
                width: "100%",
                textAlign: "center",
              }}
              onSubmit={e => {
                e.preventDefault()
                setDisabledButton(true)
                handleSuccess()
              }}
            >
              <ImputMail
                placeholder="correo electrónico"
                onChange={e => {
                  setEmail(e.target.value)
                  setSubmitted(false)
                }}
                required
                value={email}
                type="email"
              />

              <BtnSend
                disabled={disabledButton}
                style={{
                  backgroundColor: props.btnInputColorDown,
                  border: props.btnBorder,
                  borderRadius: props.btnBorderRadius,
                  color: props.btnInputColorText,
                }}
              >
                {loading ? (
                  "Enviar"
                ) : (
                  <img
                    src={Spinner}
                    alt="loading"
                    style={{
                      width: "100%",
                      height: "auto",
                      maxWidth: "22px",
                      marginRight: "auto",
                      marginLeft: "auto",
                    }}
                  ></img>
                )}
              </BtnSend>
            </form>
            <Row
              style={{
                justifyContent: "center",
                paddingRight: "2rem",
                paddingLeft: "2rem",
                marginTop: "2rem",
              }}
            >
              <p>{Parser(props.disclaimer)}</p>
            </Row>
          </Row>
        )}
      </section>
    </>
  )
}

export default ShowInscription

const Title = styled.h2`
  font-family: "Inter", sans-serif;
  font-weight: bold;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  /* margin-top: 2rem; */

  @media (max-width: 900px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`

const ImputMail = styled.input`
  padding: 1rem 4rem 1rem 1rem;
  margin-right: 2rem;
  border-radius: 6px;
  border-width: 0;
  @media (max-width: 502px) {
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 1rem 5rem 1rem 1rem;
  }
  @media (max-width: 339px) {
    padding: 1rem 3rem 1rem 1rem;
  }
`
